<template>
    <div id="vendor-item-container">
        <b-row>
            <b-col>
                <MdTitle 
                    v-bind:Text="this.editMode ? $t('VendorsListing.EditVendor'): $t('VendorsListing.AddVendor')"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.Code')"
                    v-bind:Name="'Code'"
                    v-bind:TypeProp="'text'"  
                    v-bind:MaxLengthProp="15"     
                    v-model="vendor.vendorcode"
                    v-bind:isReadOnly="isReadOnly || editMode"
                    v-bind:Id="'input_code'"
                    v-bind:isRequired="true"
                    v-bind:isValid="isCodeValid"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.Name')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'VendorName'"
                    v-bind:MaxLengthProp="50"
                    v-bind:isRequired="true"
                    v-model="vendor.name"
                    v-bind:isValid="this.isNameValid"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_patient_name'">                                     
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.Address1')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'address1'"
                    v-bind:MaxLengthProp="30"
                    v-model="vendor.address1"
                    v-bind:isReadOnly=this.isReadOnly
                    v-bind:Id="'input_patient_addr1'">                                     
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">             
                <MdEdit 
                    v-bind:Label="$t('Shared.Address2')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'address2'"
                    v-bind:MaxLengthProp="30"
                    v-model="vendor.address2"
                    v-bind:isReadOnly=this.isReadOnly
                    v-bind:Id="'input_patient_addr2'">                                     
                </MdEdit>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                        v-bind:Label="$t('Shared.Zip')"
                        v-bind:TypeProp="'text'" 
                        v-bind:Name="'zip'"
                        v-bind:MaxLengthProp="10"
                        v-model="vendor.zip"
                        v-bind:isReadOnly=this.isReadOnly
                        v-bind:Id="'input_patient_zip'"
                        v-on:blur="patientZipBlur(vendor.zip)"
                        v-on:change="patientZipChange($event)">                                     
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.City')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'city'"
                    v-bind:MaxLengthProp="25"
                    v-model="vendor.city"
                    v-bind:isReadOnly=this.isReadOnly
                    v-bind:Id="'input_patient_city'">                                     
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.State')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'state'"
                    v-bind:MaxLengthProp="2"
                    v-model="vendor.state"
                    v-bind:isReadOnly=this.isReadOnly
                    v-bind:Id="'input_patient_state'">                                     
                </MdEdit>
            </b-col>
            <b-col md="3" lg="3" sm="12">
              <MdEdit 
                     v-bind:Label="$tc('Contact.Contact')"
                     v-bind:TypeProp="'text'" 
                     v-bind:Name="'Contact'"
                     v-bind:MaxLengthProp="50"
                     v-bind:isReadOnly="isReadOnly"
                     v-model="vendor.contact"
                     v-bind:Id="'input_d_cont_ln'">                                     
               </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            
            <b-col lg="3" md="3" sm="12">
               <MdEdit 
                     v-bind:Label="$t('Shared.Phone')"
                     v-bind:TypeProp="'text'" 
                     v-bind:Name="'Phone'"
                     v-bind:Mask="'(###)###-####'"
                     v-bind:MaxLengthProp="15"
                     v-bind:isReadOnly="isReadOnly"
                     v-model="vendor.phone"
                     v-bind:Id="'input_d_ph'">                                     
               </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
               <MdEdit 
                     v-bind:Label="$t('Patient.LegalFax')"
                     v-bind:TypeProp="'text'" 
                     v-bind:Name="'Fax'"
                     v-bind:Mask="'(###)###-####'"
                     v-bind:MaxLengthProp="15"
                     v-bind:isReadOnly="isReadOnly"
                     v-model="vendor.fax"
                     v-bind:Id="'input_d_lf'">                                     
               </MdEdit>
            </b-col>    
            <b-col lg="3" md="3" sm="12">
               <MdEdit 
                     v-bind:Label="$t('Shared.Email')"
                     v-bind:TypeProp="'email'" 
                     v-bind:Name="'Email'"
                     v-bind:MaxLengthProp="50"
                     v-model="vendor.email"
                     v-bind:isReadOnly="isReadOnly"
                     v-bind:Id="'input_d_email'">
               </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('insuranceSetup.WebSite')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="50" 
                    v-bind:Name="'website'"
                    v-model="vendor.website"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_insu_webs'"
                    />     
            </b-col>
        </b-row>
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('Shared.Active')" 
                    v-bind:Name="'checkbox-isactive'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="vendor.isactive"                     
                />
            </b-col>         
        </b-row>
        <MdTitle v-bind:Text="$t('Shared.Remarks')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        <b-row>
            <b-col md="12" lg="12" sm="12">
                <MdMemo 
                    v-bind:Name="'Remarks'"
                    v-model="vendor.remarks"
                    v-bind:Rows="'6'"
                    v-bind:MaxRows="'250'" 
                    v-bind:Id="'input_Remartks'"/>
            </b-col>
        </b-row>
       

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBack'"
                v-bind:TextToolTip="$t('ePharmacyItemsReceived.BackToList')" 
                v-on:click="goBack"
                v-bind:ClassProp="'mx-2 btn-login'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="(this.isReadOnly)?'primary mx-2':'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly=this.isReadOnly
                v-bind:Name="'btn_save_inventory_item'"
            />
        </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import PharmacyVedorsService from '@/services/pharmacyvendor.service'
import GlobalService from '@/services/global.service'
import Utils from '@/common/utils.js'

let elemSaveBtn = '';    
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                title: this.$t('Shared.PatientAllergies'),
                okTitle: this.$t('Shared.BtnSave'),
                cancelTitle: this.$t('Shared.BtnDismiss'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning'
            })
            .then(value => {
                if(!value){
                    next();
                } else {
                    this.SaveOrEdit();
                    next();
                }
            })		
        } else {
            next()
        }
    },

    mixins: [ShowMessage, DBFunctions],
    props: {
        editMode: Boolean,
    },
    data() {
        return {
           
            OptionsRightMenu:{
                visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                Mode:this.editMode,
                favButtonAtion:false          
            },

            isReadOnly: false,
            isEditable: true,
            vendor: {
                vendorcode: null,
                isactive: true,
                  // Basic information
                name: '',
                // Address information
                address1: '',
                address2: '',
                zip: '',
                city: '',
                state: '',
                // Contact information
                contact: '', // ContactLastName maps to this
                phone: '',
                fax: '',
                email: '',
                // Additional fields
                website: '',
                remarks: ''
            },
            isCodeValid: true,
            isNameValid: true,
            patientZipChanged:false,
            patientLegalZipChanged:false,
        }
    },

    methods: {
        goBack() {
            this.$router.push({ name: 'vendors' });
        },

        SaveOrEdit() {
            if(!this.isReadOnly) {
                if (this.validate_required()) {
                    elemSaveBtn.setAttribute("disabled",'');

                    if (this.editMode) { 
                        this.update();
                    } else {            
                        this.save();
                    }
                }  else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
                }
            }
        },

        save() {
            PharmacyVedorsService
                .add(this.vendor)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                            , 50); 

                        this.goBack();
                    }
                })
                .catch((error) => {
                    elemSaveBtn.removeAttribute("disabled");
                    this.showResponseErrorMessage(error);
                });
        },

        update() {
            PharmacyVedorsService
                .update(this.$route.params.recId, this.vendor)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                            , 50); 

                        this.goBack();
                    }
                })
                .catch((error) => {
                    elemSaveBtn.removeAttribute("disabled");
                    this.showResponseErrorMessage(error);
                });
        },

        getVendor(){
            if(this.editMode){
                PharmacyVedorsService.Get(this.$route.params.recId)
                    .then((response) => {
                        if(response.status == '200' && response.data){
                            var vendor = {
                                vendorcode: response.data.vendorcode,
                                isactive: response.data.isactive === 'Y',
                                name: response.data.name,
                                address1: response.data.address1,
                                address2: response.data.address2,
                                zip: response.data.zip,
                                city: response.data.city,
                                state: response.data.state,
                                contact: response.data.contact,
                                phone: response.data.phone,
                                fax: response.data.fax,
                                email: response.data.email,
                                website: response.data.website,
                                remarks: response.data.remarks
                            }
                            this.vendor = vendor;  
                        }   
                    })
                    .catch((error) => {                    
                        this.showResponseErrorMessage(error);          
                    }); 
            }
        },

        validate_required() {
            this.isNameValid = this.vendor.name.length > 0 ? true : false;
            this.isCodeValid = !Utils.isNullOrEmptyString(this.vendor.vendorcode);
            return this.isCodeValid && this.isNameValid;
        },

        beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''	
            }
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        patientZipBlur: function (value) {
            if (this.patientZipChanged && value.trim()!== '') {
                GlobalService.getCityAndStateByZipCode(value)
                    .then((response) => {
                        if(response.status == '200' && response.data){
                            var obj = response.data
                        if(obj.city) {
                                this.vendor.city = obj.city;
                                this.vendor.state = obj.state;
                            }
                            this.patientZipChanged = false;
                        }  
                    })
                    .catch((error) => {
                        this.vendor.city = '';
                        this.vendor.state = '';
                    if(error.response.status !== 404 && error.response.status !== 500){
                        if(error.response) {
                            this.showMessage(this.$tc('Msg.Error'),error,"error");
                        }
                    }
                        
                });  
            }
        },

        patientZipChange: function() {
            this.patientZipChanged = true;
        },

    },

    async mounted() {

        this.getVendor();
        setTimeout( function() {
            elemSaveBtn = document.getElementById('btn_save_inventory_item');
            elemSaveBtn.setAttribute('disabled','');
        }, 50, this );
    },

    created() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        EventBus.$on("onChanged", function (e) {       
            this.pendingChanges = e.Changed
            this.checkUserAction();
        }.bind(this));
    
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
}
</script>